export const PLAN_REQUEST = 'seatPlan/PLAN_REQUEST';
export const SET_PLAN = 'seatPlan/SET_PLAN';
export const CLEAR_PLAN = 'seatPlan/CLEAR_PLAN';

export const LEGEND_REQUEST = 'seatPlan/LEGEND_REQUEST';
export const SET_LEGEND = 'seatPlan/SET_LEGEND';
export const CLEAR_LEGEND = 'seatPlan/CLEAR_LEGEND';
